import Clamps from "clamps";

class ReadMore {
  constructor(element) {
    if (!(element instanceof HTMLElement)) {
      throw new TypeError("Invalid element");
    }

    this.container = element;
    this.modal = this.container.closest(".modal");
    this.toggle = this.container.nextElementSibling;

    Clamps(this.container);

    this.checkHeights();

    this.toggle.addEventListener("click", this.toggleCollapsed.bind(this));
    this.modal.addEventListener("modal.opened", this.checkHeights.bind(this))
  }
  toggleCollapsed(ev){
    ev.preventDefault();

    this.toggle.innerText = this.container.classList.contains("collapsed") ? "Read less" : "Read more";
    this.container.classList.toggle("collapsed");
  }

  checkHeights() {
    const collapsed = this.container.offsetHeight;
    this.container.classList.remove("collapsed");

    const open = this.container.offsetHeight;
    this.container.classList.add("collapsed");

    this.toggle.style.display = (collapsed >= open)  ? "none" : "block";
  }
}

export default ReadMore;
